// global
import React from 'react';
import PropTypes from 'prop-types';
import { Progress } from 'semantic-ui-react';
// local
import SnackbarList from 'app/components/commons/snackbar/SnackbarList';
import NotificationTimeout from 'app/components/commons/notification/NotificationTimeout';
// stylesheet
import styles from './Page.module.scss';

function Page(props) {
  const { id, loading, children } = props;
  return (
    <div id={id} className={styles.page}>
      {loading && (
        <Progress
          size='tiny'
          percent={100}
          color='teal'
          style={{ position: 'absolute', width: '100%', top: '58px' }}
          indicating
        />
      )}
      <div className={styles.shadow}></div>
      {children}
      <NotificationTimeout />
      <SnackbarList />
    </div>
  );
}

Page.propTypes = {
  id: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  children: PropTypes.any
};

export default Page;
